export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Strength.d5a1dd1e.jpg";